<script setup lang="ts">
interface Props {
    title?: string;
    items: string[];
    iconUrl?: string;
}

defineProps<Props>();
</script>

<template>
    <div>
        <img v-if="iconUrl" :src="iconUrl" alt="prospektus-service-icon" class="mb-4 mx-auto" />
        <h2 v-if="title" class="font-semibold text-xl font-inter text-center">{{ title }}</h2>
        <ul>
            <li v-for="item in items" :key="item" class="flex items-center gap-4 p-3">
                <span class="material-symbols-outlined text-3xl">expand_circle_right</span>
                <p class="text-content leading-7 font-inter">{{ item }}</p>
            </li>
        </ul>
    </div>
</template>
